import React from 'react';
import AppContainer from '../app-container';
import * as stageActions from '../../actions/stages';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';
import moment from 'moment';
import LocalizedStrings from '../../localization/strings';
import Loading from '../../components/loading';
import DocumentTitle from 'react-document-title';

class StagesPageContainer extends AppContainer {
    getSeasonId(){
        return this.props.params.seasonId ? this.props.params.seasonId: window.CARE_CONFIG.settings.season.id;
    }

    componentWillMount() {
        this.props.actions.fetchAllStages(this.getSeasonId());
    }
    renderRegistrationButton(stage) {
        if (stage.registration_enabled) {
            if (stage.external_website_registration) {
                return (
                    <a className="btn btn-main-color inline first-uppercase" href={stage.external_registration_link}>{LocalizedStrings.registration}</a>
                )
            }
            return (
                <Link to={`/stages/${stage.id}/registration`} className="btn btn-main-color inline first-uppercase">
                    {LocalizedStrings.registration}
                </Link>
            )
        }
    }

    renderResultsButton(stage) {
        if (stage.has_results) {
            return (
                <Link to={`/stages/${stage.id}/results`} className="btn btn-main-color inline first-uppercase mt-10">
                    {LocalizedStrings.results}
                </Link>
            )
        }
    }

    renderRegisterToAllButton(stages) {
        return stages.filter((stage) => {
            return stage.register_to_all_stages && stage.registration_enabled
        }).map(stage => {
            return (

                <Link key={`register-to-all-${new Date().getTime()}`} to={`/stages/${stage.id}/registration`} className="btn btn-main-color inline first-uppercase">
                    {LocalizedStrings.registerToAllStages}
                </Link>
            )
        });
    }

    renderRegisterToCustomStages(stages){
        return stages.filter((stage) => {
            return stage.register_to_custom_stages  && stage.registration_enabled
        }).map(stage => {
            return (

                <Link key={`register-to-custom-${new Date().getTime()}`} to={`/stages/${stage.id}/registration`} className="btn btn-main-color inline first-uppercase mb-20">
                    {stage.name}
                </Link>
            )
        });
    }

    renderTable(stages) {
        return (
            <table className="table responsive">
                <thead>
                    <tr>
                        <th>
                            {LocalizedStrings.stage}
                        </th>
                        <th>
                            {LocalizedStrings.date}
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {stages.filter((stage) => {
                        return !stage.register_to_all_stages && !stage.global_results_stage && !stage.register_to_custom_stages
                    }).map(stage => {
                        return (
                            <tr key={`stage-${stage.id}`}>
                                <td>{stage.name}</td>
                                <td>{moment(stage.stage_date).format('YYYY-MM-DD HH:mm')}</td>
                                <td className="actions">
                                    {this.renderRegistrationButton(stage)}
                                    {this.renderResultsButton(stage)}
                                    {stage.external_website_registration
                                        ? <a className="btn btn-main-color inline first-uppercase" href={stage.external_participants_link}>{LocalizedStrings.participants}</a>
                                        : <Link to={`/stages/${stage.id}/participants`} className="btn btn-main-color inline first-uppercase">
                                            {LocalizedStrings.participants}
                                        </Link>}
                                    {stage.external_website_registration
                                        ? <a className="btn btn-main-color inline first-uppercase" href={stage.external_regulations_link}>{LocalizedStrings.regulations}</a>

                                        : <Link to={`/stages/${stage.id}/regulations`} className="btn btn-main-color inline first-uppercase">
                                            {LocalizedStrings.regulations}
                                        </Link>}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }
    renderContent(){
       return <div>
           <div className="mb-30">
               {this.renderRegisterToAllButton(this.props.stages.items)}
           </div>
           {this.renderRegisterToCustomStages(this.props.stages.items)}
           {this.renderTable(this.props.stages.items)}
       </div>
    }

    render() {
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.stages)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.stages}</span >
                        </h1>
                        {this.props.stages.loading ?<Loading/>: this.renderContent() }
                    </div>
                </div >
            </DocumentTitle>
        )
    }
}

export default connect(function(state) {
    return {stages: state.stage.availableStages};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...stageActions
        }, dispatch)
    };
})(StagesPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/stages-page-container.js